module.exports = __webpack_public_path__ + "img/30290-5.prt.ffa172ba.jpg";